<template>
  <section class="section h-100">
    <admin-section-header icon="chat" title="My Chat" />
    <SectionUnderDevelopment/>
    <!-----
    <div class="columns" style="max-height: 700px;">
      <div class="column is-3">
        <section class="section is-bordered scroll-column">
          <h4 class="title is-4 is-pink-dark">Ejecutivos</h4>
          <div v-for="i in 20" class="container is-flex flex-wrap" style="margin-bottom: 1em;">

            <figure class="image is-rounded is-32x32" style="margin: auto; margin-left: 0; margin-right: 1em;">
              <img src="@/assets/avatar_client.png" class="m-auto is-rounded is-pink is-32x32" style="border: solid 2px;"/>
            </figure>

            <div class="flex flex-wrap" style="line-height: 1;">
              <strong class="">Noelia Castillo</strong>
              <p>Cargo</p>
            </div>
          
          </div>

        </section>
      </div>

      <div class="column is-6">
        <section class="section is-bordered h-100">
          <request-chat></request-chat>
        </section>
      </div>
      <div class="column is-3">
          <section class="section is-bordered scroll-column">
          <h4 class="title is-4 is-pink-dark">Compañías</h4>
          <div v-for="i in 20" class="container is-flex flex-wrap" style="margin-bottom: 1em;">

            <figure class="image is-rounded is-32x32" style="margin: auto; margin-left: 0; margin-right: 1em;">
              <img src="@/assets/avatar_client.png" class="m-auto is-rounded is-pink is-32x32" style="border: solid 2px;"/>
            </figure>

            <div class="flex flex-wrap" style="line-height: 1;">
              <strong class="">Noelia Castillo</strong>
              <p>Cargo</p>
            </div>
          
          </div>


        </section>
      </div>
    </div>

    ---->
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import RequestChat from '@/components/on-board/RequestChat.vue'
import SectionUnderDevelopment from '@/components/common/SectionUnderDevelopment.vue'
export default {
  name: 'MyChat',
  components: { AdminSectionHeader, RequestChat, SectionUnderDevelopment },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'MyChat'],
      title: 'MyChat'
    })
  }
}
</script>

<style scoped lang="scss">
  .is-bordered {
    border: solid 2px var(--rosa-dark-eco);
    border-radius: 10px;
  }
  .scroll-column {
    height: 100%;
    overflow: scroll;
    // max-height: 700px;
  }
  .h-100 {
    height: 100%;
  }
</style>
